export const LayoutStyle = {
  CardWidth: 640*0.3,
  CardHeight: 440*0.3,
  PaddingH: 100,
  PaddingV: 40
};



// WEBPACK FOOTER //
// ./style.js